import React, { useContext, useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import { ContextGloball } from '../Context/ContextGlobal';
import { Row, Col, Form, Button, ButtonGroup } from 'react-bootstrap';

const server = process.env.REACT_APP_SERVER;

function ReporteProveedores() {
    const { setLoading } = useContext(ContextGloball);
    const [ventana, setVentana] = useState(0);
    const [regional, setRegional] = useState('');
    const [proveedor, setProveedor] = useState("");
    const [proveedores, setProveedores] = useState([]);
    const [numeroSemana, setNumeroSemana] = useState(0);
    
    // Estos estados guardarán el formato YYYY-MM-DD para el input type="date"
    const [fechaInicial, setFechaInicial] = useState("");
    const [fechaFinal, setFechaFinal] = useState("");
    const [productos, setProductos] = useState([]);

    // --- NUEVAS FUNCIONES DE APOYO ---

    // Convierte YYYY-MM-DD a DD/MM/YYYY (para enviar a la API)
    const formatToBackend = (dateStr) => {
        if (!dateStr || !dateStr.includes('-')) return dateStr;
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    };

    // Convierte DD/MM/YYYY a YYYY-MM-DD (para mostrar en el input date)
    const formatToInput = (dateStr) => {
        if (!dateStr || !dateStr.includes('/')) return dateStr;
        const [day, month, year] = dateStr.split('/');
        return `${year}-${month}-${day}`;
    };

    // --- LOGICA EXISTENTE ---

    const getProveedores = async (fechaInicialAux, fechaFinalAux) => {
        var info = JSON.parse(localStorage.getItem('__react_session__'))
        setRegional(info.regional);
        setLoading(true);
        try {
            var response = await fetch(`${server}/reporte/getProveedores`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({ 'regional': info.regional })
            });
            if (response.ok) {
                let data = await response.json();
                setProveedores(data.ok);
                setProveedor(data.ok[0].ID_PROVEEDOR)
                // Usamos las fechas auxiliares que vienen del useEffect inicial
                getProductosDeProveedor(data.ok[0].ID_PROVEEDOR, fechaInicialAux, fechaFinalAux)
            } else {
                setLoading(false);
                MsgUtils.msgError("No se pudo obtener los proveedores");
            }
        } catch (networkError) {
            setLoading(false);
            MsgUtils.msgError("Error de conexión: " + networkError.message);
        }
    }

    async function getProductosDeProveedor(idProveedor, fIni, fFin) {
        // Normalizamos las fechas al formato DD/MM/YYYY antes de enviar al server
        const fechaEnvioIni = fIni.includes('-') ? formatToBackend(fIni) : fIni;
        const fechaEnvioFin = fFin.includes('-') ? formatToBackend(fFin) : fFin;

        let divProv = [147, 123, 108].includes(Number(idProveedor));
        let idReal = idProveedor > 10000 ? idProveedor / 100 : idProveedor;
        let divAux = idProveedor > 10000;

        let info = JSON.parse(localStorage.getItem('__react_session__'))
        setLoading(true);
        try {
            var response = await fetch(`${server}/reporte/getProductosDeProveedores`, {
                method: 'POST',
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    'regional': info.regional,
                    'id_proveedor': idReal,
                    'fecha_inicial': fechaEnvioIni,
                    'fecha_final': fechaEnvioFin,
                })
            });
            if (response.ok) {
                let data = await response.json();
                const config = {
                    147: [165], 123: [97, 516], 108: [47, 48, 136]
                }
                let permitidos = config[idReal] || [];

                if (divAux) {
                    data.ok = data.ok.filter(p => permitidos.includes(p.ID_PRODUCTO));
                } else if (divProv) {
                    data.ok = data.ok.filter(p => !permitidos.includes(p.ID_PRODUCTO));
                }
                setProductos(data.ok);
                setLoading(false);
            } else {
                setLoading(false);
                MsgUtils.msgError("Error al obtener productos");
            }
        } catch (networkError) {
            setLoading(false);
            MsgUtils.msgError("Error de red: " + networkError.message);
        }
    }

    function calcularFecha(semana) {
        let dias = getFormattedDatesOfWeek(2025, semana);
        // Actualizamos los inputs visuales (convertimos DD/MM/YYYY a YYYY-MM-DD)
        setFechaInicial(formatToInput(dias[0]));
        setFechaFinal(formatToInput(dias[dias.length - 1]));
        getProductosDeProveedor(proveedor, dias[0], dias[dias.length - 1]);
    }

    function getFormattedDatesOfWeek(year, weekNumber) {
        const jan4 = new Date(year, 0, 4);
        const jan4Day = jan4.getDay() || 7;
        const weekStart = new Date(jan4);
        weekStart.setDate(jan4.getDate() - (jan4Day - 1) + (weekNumber - 1) * 7);
        const formattedDates = [];
        for (let i = 0; i < 7; i++) {
            const currentDate = new Date(weekStart);
            currentDate.setDate(weekStart.getDate() + i);
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = currentDate.getFullYear();
            formattedDates.push(`${day}/${month}/${year}`);
        }
        return formattedDates;
    }

    function getNumeroSemanaHoy(date = new Date()) {
        const tempDate = new Date(date.getTime());
        tempDate.setHours(0, 0, 0, 0);
        tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7));
        const firstThursday = new Date(tempDate.getFullYear(), 0, 4);
        return 1 + Math.round(((tempDate - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7);
    }

    useEffect(() => {
        let semana = getNumeroSemanaHoy();
        let diasSemanaActual = getFormattedDatesOfWeek(2025, semana);
        setNumeroSemana(semana);
        // Guardamos en formato input para que los calendarios se llenen
        setFechaInicial(formatToInput(diasSemanaActual[0]));
        setFechaFinal(formatToInput(diasSemanaActual[diasSemanaActual.length - 1]));
        getProveedores(diasSemanaActual[0], diasSemanaActual[diasSemanaActual.length - 1]);
    }, [])

    return (
        <>
            {ventana === 0 && <>
                <div className='container-fluid bg-dark py-3'>
                    <Row className="align-items-end">
                        <Col xs={12} md={3}>
                            <Form.Group>
                                <Form.Label className="text-white">Proveedor</Form.Label>
                                <Form.Select
                                    value={proveedor}
                                    onChange={(e) => { 
                                        setProveedor(e.target.value); 
                                        getProductosDeProveedor(e.target.value, fechaInicial, fechaFinal); 
                                    }}
                                >
                                    {proveedores.map((p) => (
                                        <option key={p.ID_PROVEEDOR} value={p.ID_PROVEEDOR}>{p.NOMBRE}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col xs={6} md={1}>
                            <div className='text-white text-center small'># Semana</div>
                            <ButtonGroup size="sm" className="w-100">
                                <Button variant='light' onClick={() => { setNumeroSemana(numeroSemana - 1); calcularFecha(numeroSemana - 1); }}>
                                    <i className="fa-solid fa-chevron-left"></i>
                                </Button>
                                <div className='bg-light fw-bold text-dark px-2 d-flex align-items-center'>{numeroSemana}</div>
                                <Button variant='light' onClick={() => { setNumeroSemana(numeroSemana + 1); calcularFecha(numeroSemana + 1); }}>
                                    <i className="fa-solid fa-chevron-right"></i>
                                </Button>
                            </ButtonGroup>
                        </Col>

                        {/* --- NUEVOS INPUTS DE FECHA --- */}
                        <Col xs={12} md={2}>
                            <Form.Group>
                                <Form.Label className="text-white small">Desde:</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    value={fechaInicial} 
                                    onChange={(e) => setFechaInicial(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={2}>
                            <Form.Group>
                                <Form.Label className="text-white small">Hasta:</Form.Label>
                                <Form.Control 
                                    type="date" 
                                    value={fechaFinal} 
                                    onChange={(e) => setFechaFinal(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col xs={12} md={2}>
                            <Button 
                                variant="primary" 
                                className="w-100"
                                onClick={() => getProductosDeProveedor(proveedor, fechaInicial, fechaFinal)}
                            >
                                Consultar Rango
                            </Button>
                        </Col>
                    </Row>
                </div>
                
                {/* Tabla se mantiene igual... */}
                <div className='table-responsive'>
                    <table className="table table-dark table-striped table-hover">
                        <thead className='fw-bold'>
                            <tr>
                                <th>Producto</th>
                                <th>Unidad</th>
                                <th className='text-center'>Precio unitario</th>
                                <th className='text-center'>Ingresos Almacen</th>
                                <th className='text-center'>Ingresos Planta</th>
                                <th className='text-center'>Ingresos Sucursales</th>
                                <th className='text-center'>Traspasos Planta</th>
                                <th className='text-center'>Bajas Sucursales</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productos.map((producto, index) => (
                                <tr key={index}>
                                    <td>{producto.DESCRIPCION}</td>
                                    <td>{producto.DESCRIPCION_UNIDAD}</td>
                                    <td className='text-center'>{producto.PRECIO_UNITARIO[0]?.PRECIO.toFixed(2) ?? '-'}</td>
                                    <td className='text-center'>{producto.DETALLE_INGRESOS_ALMACEN[0]?.CANTIDAD ?? '0'}</td>
                                    <td className='text-center'>{producto.DETALLE_INGRESOS_PLANTA[0]?.CANTIDAD ?? '0'}</td>
                                    <td className='text-center'>{producto.DETALLE[0]?.CANTIDAD ?? '0'}</td>
                                    <td className='text-center'>{producto.DETALLE_TRASPASOS_PLANTA[0]?.CANTIDAD ?? '0'}</td>
                                    <td className='text-center'>{producto.DETALLE_BAJAS_SUCURSALES[0]?.CANTIDAD ?? '0'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>}
        </>
    )
}

export default ReporteProveedores;